// extracted by mini-css-extract-plugin
export default {"success_message_wrapper":"SuccessMessage_success_message_wrapper__An69N","back_btn":"SuccessMessage_back_btn__qG3R0"};